import { createContext, useCallback, useRef, type ReactNode } from "react";

interface DeckPositionContextType {
  getDeckRect: () => DOMRect | null;
  registerDeck: (el: HTMLElement | null) => void;
}

export const DeckPositionContext = createContext<DeckPositionContextType>({
  getDeckRect: () => null,
  registerDeck: () => {},
});

export function DeckPositionProvider({ children }: { children: ReactNode }) {
  const deckElRef = useRef<HTMLElement | null>(null);

  const registerDeck = useCallback((el: HTMLElement | null) => {
    deckElRef.current = el;
  }, []);

  const getDeckRect = useCallback(() => {
    return deckElRef.current?.getBoundingClientRect() ?? null;
  }, []);

  return (
    <DeckPositionContext.Provider value={{ getDeckRect, registerDeck }}>
      {children}
    </DeckPositionContext.Provider>
  );
}
